'use client'

import { createContext } from 'react'

export interface AudioRegistration {
  id: string
  audio: HTMLAudioElement
  group?: string
  onUpdate: (status: AudioStatus) => void
  onPlayError?: (error: unknown) => void
}

export interface AudioStatus {
  isPlaying: boolean
  isLoading: boolean
  currentTime: number
  duration: number
  progress: number
}

export const DEFAULT_AUDIO_STATUS: AudioStatus = {
  isPlaying: false,
  isLoading: false,
  currentTime: 0,
  duration: 0,
  progress: 0,
}

export interface RegisteredPlayer {
  id: string
  group?: string
  audio: HTMLAudioElement
  onUpdate: (status: AudioStatus) => void
  onPlayError?: (error: unknown) => void
  toggle: () => void
}

export interface AudioContextType {
  register: (props: AudioRegistration) => RegisteredPlayer
  deregister: (id: string) => void
}

export const AudioContext = createContext<AudioContextType | null>(null)
